// extracted by mini-css-extract-plugin
export default {"inARow":"TicketsTable_inARow__ojumd","notOnMobile":"TicketsTable_notOnMobile__VDpDW","\t":"TicketsTable_-__6Wc5-","tableContainerHolder":"TicketsTable_tableContainerHolder__alNPI"};